import React from "react";
import { Check } from "lucide-react";

function StepCircle({ step, status }) {
  const base =
    "flex items-center justify-center w-9 h-9 sm:w-10 sm:h-10 rounded-full text-sm font-josefin font-medium shrink-0 transition duration-200 ease-in-out";

  if (status === "complete") {
    return (
      <div className={`${base} bg-primaryDark text-white`}>
        <Check size={18} strokeWidth={2.5} />
      </div>
    );
  }

  if (status === "active") {
    return (
      <div className={`${base} bg-primaryDark text-white`}>{step}</div>
    );
  }

  return (
    <div
      className={`${base} border-2 border-greyLight text-greyLight bg-white`}
    >
      {step}
    </div>
  );
}

function Connector({ active }) {
  return (
    <div
      className={`h-0.5 flex-1 min-w-[2rem] sm:min-w-[4rem] transition duration-200 ease-in-out ${
        active ? "bg-primaryDark" : "bg-greyLight"
      }`}
    />
  );
}

function OnboardingStepper({ currentStep }) {
  const getStatus = (step) => {
    if (step < currentStep) return "complete";
    if (step === currentStep) return "active";
    return "pending";
  };

  return (
    <div className="flex items-center justify-center w-full max-w-md px-2">
      <StepCircle step={1} status={getStatus(1)} />
      <Connector active={currentStep > 1} />
      <StepCircle step={2} status={getStatus(2)} />
      <Connector active={currentStep > 2} />
      <StepCircle step={3} status={getStatus(3)} />
    </div>
  );
}

export default OnboardingStepper;
